const messages = require('./th-TH/messages.json');

export default messages;
